const comMain = () => {
  if (document.querySelector("section#jsComSecMain") !== null) {



    let sW = window.innerWidth;
    let sH = window.innerHeight;

    let secMain = document.getElementById('jsComSecMain');
    let imgWrap = secMain.querySelector('.js-img-wrap');
    let clipBoxs = imgWrap.querySelectorAll('.js-clip-box');
    let coverBox = imgWrap.querySelector('.js-cover-box');


    // ピン
    let pin = gsap.to(imgWrap, {
      scrollTrigger: {
        trigger: imgWrap,
        start: "50% 50%",
        endTrigger: 'body',
        end: '100% 0%',
        pin: true,
        pinSpacing: false,
        // markers: true
      }
    });


    // 左
    let clipPath0_0
    let clipPath0_1
    let clipPath0_2
    if (sW > 750) {
      clipPath0_0 = 'polygon(calc(50% - 245px) 140px, calc(50% - 15px) 140px, calc(50% - 15px) 970px, calc(50% - 245px) 970px)'
      clipPath0_1 = 'polygon(calc(50% - 245px) 0px, calc(50% - 15px) 0px, calc(50% - 15px) 100%, calc(50% - 245px) 100%)'
      clipPath0_2 = 'polygon(calc(0% - 0px) 0px,calc(100% - 0px) 0px,calc(100% - 0px) 100%,calc(0% - 0px) 100%)'
    } else {
      clipPath0_0 = 'polygon(125px 70px, 200px 70px, 200px 485px, 125px 485px)'
      clipPath0_1 = 'polygon(125px 0px, 200px 0px, 200px 100%, 125px 100%)'
      clipPath0_2 = `polygon(0px 0px, ${sW}px 0px, ${sW}px 100%, 0px 100%)`
    }

    gsap.to(clipBoxs[0], {
      clipPath: clipPath0_0,
      duration: 1.5,
      ease: "power2.inOut",
      delay: 1,
    });

    const to0 = gsap.timeline({
      scrollTrigger: {
        trigger: secMain,
        start: "0% 0%",
        end: "100% 0%",
        scrub: 2,
        // markers: true
      },
    });

    to0.to(
      clipBoxs[0], //アニメーションする要素
      {
        keyframes: [
          // { clipPath: clipPath0_0 },
          { clipPath: clipPath0_1 },
          { clipPath: clipPath0_2 },
        ],
      }
    );


    // 中
    let clipPath1_0
    let clipPath1_1
    let clipPath1_2
    if (sW > 750) {
      clipPath1_0 = 'polygon(50% 140px, calc(50% + 230px) 140px, calc(50% + 230px) 820px, 50% 820px)'
      clipPath1_1 = 'polygon(50% 0px, calc(50% + 230px) 0px, calc(50% + 230px) 100%, 50% 100%'
      clipPath1_2 = 'polygon(0% 0px, calc(100% + 0px) 0px, calc(100% + 0px) 100%, 0% 100%'
    } else {
      clipPath1_0 = 'polygon(205px 70px, 280px 70px, 280px 410px, 205px 410px)'
      clipPath1_1 = 'polygon(205px 0px, 280px 0px, 280px 100%, 205px 100%)'
      clipPath1_2 = `polygon(0px 0px, ${sW}px 0px, ${sW}px 100%, 0px 100%)`
    }

    gsap.to(clipBoxs[1], {
      clipPath: clipPath1_0,
      duration: 1.5,
      ease: "power2.inOut",
      delay: 1,
    });

    const to1 = gsap.timeline({
      scrollTrigger: {
        trigger: secMain,
        start: "0% 0%",
        end: "100% 0%",
        scrub: 2,
        // markers: true
      },
    });

    to1.to(
      clipBoxs[1], //アニメーションする要素
      {
        keyframes: [
          // { clipPath: clipPath1_0 },
          { clipPath: clipPath1_1 },
          { clipPath: clipPath1_2 },
        ],
      }
    );


    // 右
    let clipPath2_0
    let clipPath2_1
    let clipPath2_2
    if (sW > 750) {
      clipPath2_0 = 'polygon(calc(50% + 245px) 140px, calc(50% + 475px) 140px, calc(50% + 475px) 700px, calc(50% + 245px) 700px)'
      clipPath2_1 = 'polygon(calc(50% + 245px) 0px, calc(50% + 475px) 0px, calc(50% + 475px) 100%, calc(50% + 245px) 100%)'
      clipPath2_2 = 'polygon(calc(0% + 0px) 0px, calc(100% + 0px) 0px, calc(100% + 0px) 100%, calc(0% + 0px) 100%)'
    } else {
      clipPath2_0 = 'polygon(285px 70px, 360px 70px, 360px 350px, 285px 350px)'
      clipPath2_1 = 'polygon(285px 0px, 360px 0px, 360px 100%, 285px 100%)'
      clipPath2_2 = `polygon(0px 0px, ${sW}px 0px, ${sW}px 100%, 0px 100%)`
    }

    gsap.to(clipBoxs[2], {
      clipPath: clipPath2_0,
      duration: 1.5,
      ease: "power2.inOut",
      delay: 1,
    });

    const to2 = gsap.timeline({
      scrollTrigger: {
        trigger: secMain,
        start: "0% 0%",
        end: "100% 0%",
        scrub: 2,
        // markers: true
      },
    });

    to2.to(
      clipBoxs[2], //アニメーションする要素
      {
        keyframes: [
          // { clipPath: clipPath2_0 },
          { clipPath: clipPath2_1 },
          { clipPath: clipPath2_2 },
        ],
      }
    );


    // カバー
    let end = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secMain,
        start: "120% 0%",
        onEnter: () => coverBox.classList.add('act'),
        // onLeave: () => console.log("onLeave"),
        // onEnterBack: () => console.log("onEnterBack"),
        onLeaveBack: () => coverBox.classList.remove('act'),
        // markers: true,
      },
    })



    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        pin.scrollTrigger.refresh()
        to0.scrollTrigger.refresh()
        to1.scrollTrigger.refresh()
        to2.scrollTrigger.refresh()
        end.scrollTrigger.refresh()
      });
    });
    observer.observe(target);



  }
}
export default comMain;